import { render, staticRenderFns } from "./ServiceBase.vue?vue&type=template&id=e47570c6&"
import script from "./ServiceBase.vue?vue&type=script&lang=js&"
export * from "./ServiceBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports